import {Empty, Loader, FolderBookmarkIcon} from 'common/components'
import {UserProjectsList, useGetUserProjects, getArchivedProjects} from '..'

export default function UserArchivedProjects() {
  const {data: projects} = useGetUserProjects()

  if (!projects) return <Loader />

  const archivedProjects = getArchivedProjects(projects)

  if (!archivedProjects.length)
    return (
      <Empty
        icon={<FolderBookmarkIcon width={40} height="100%" />}
        title="archived projects"
      />
    )

  return <UserProjectsList projects={archivedProjects} />
}
